module.exports = __webpack_public_path__ + "static/comingsoon1-0b03a35800e973d38ed3bdc22893f2a3.png";